<template>
	<section
		v-if="footnoteItems.length > 0 || disclaimerItems.length > 0"
		:class="[
			'terms-conditions',
			{ 'simple-disclaimers-section': simpleDisclaimerTemplate }
		]"
	>
		<div class="container p4">
			<template v-if="!simpleDisclaimerTemplate">
				<h3 class="h3 pdp__subhead">Disclosures and footnotes</h3>
				<div class="terms">
					<template v-for="(footnoteItem, i) in footnoteItems">
						<h3
							v-if="footnoteItem.label"
							class="terms__label p4 --bold"
							:key="`footnotelabel-${i + 1}`"
							v-html="footnoteItem.label"
						/>
						<span
							:key="`footnoteitemnum-${i + 1}`"
							class="terms__item-num"
							aria-hidden="true"
						/>
						<span
							:key="`footnotevisuallyhidden-${i + 1}`"
							class="visually-hidden"
							>{{ i + 1 }}</span
						>
						<p
							class="terms__item"
							:key="`footnoteitem-${i + 1}`"
							:id="`footnote-${i + 1}`"
							v-html="footnoteItem.text"
						/>
					</template>
				</div>
			</template>

			<div class="disclaimers">
				<hr
					v-if="simpleDisclaimerTemplate && includeSeparator"
					class="separator"
				/>
				<template v-for="(disclaimerItem, i) in disclaimerItems">
					<p
						class="disclaimer__item"
						:key="`disclaimeritem-${i + 1}`"
						:id="`disclaimer-${i + 1}`"
						v-html="disclaimerItem"
					/>
				</template>
			</div>
		</div>
	</section>
</template>

<script>
export default {
	name: "Terms",

	props: {
		footnoteItems: {
			type: Array,
			required: false,
			default: () => []
		},

		disclaimerItems: {
			type: Array,
			required: false,
			default: () => []
		},

		simpleDisclaimerTemplate: {
			type: Boolean,
			default: false
		},

		includeSeparator: {
			type: Boolean,
			default: false
		}
	}
};
</script>

<style lang="scss" scoped>
.terms-conditions {
	padding: 60px 0;
}

.terms {
	counter-reset: terms-counter;
	padding: 0 12px 0 18px;

	@include from-md() {
		margin-bottom: 25px;
	}

	@include from-lg() {
		margin-left: 0;
		max-width: 960px;
	}

	p:last-child {
		margin-bottom: 0;
	}
}

.terms__label {
	margin-bottom: 0;
}

.terms__item {
	@include p4;

	margin: 0 0 20px;
	position: relative;
}

.terms__item-num {
	counter-increment: terms-counter;
	position: relative;
	&::before {
		content: counter(terms-counter);
		left: 0;
		padding-right: 12px;
		position: absolute;
		top: 0;
		transform: translateX(-100%);
	}
}

.terms + .disclaimers {
	@include to-md() {
		margin-top: 24px;
	}
}

.disclaimers {
	@include from-lg() {
		max-width: 960px;
	}

	a {
		color: $color--red;
		text-decoration: underline;
	}
}

.disclaimer__item {
	@include p4;
	position: relative;

	&:not(:last-child) {
		margin: 0 0 2em;
	}

	&::before {
		left: 0;
		padding-right: 12px;
		position: absolute;
		top: 0;
		transform: translateX(-100%);
	}
}

.simple-disclaimers-section {
	padding: 48px 0 0;
}

.separator {
	margin-bottom: 2em;
	height: 2px;
	border: none;
	color: $color--lighter-gray;
	background-color: $color--lighter-gray;
}
</style>
